import { ErrorSummary } from "nhsuk-react-components"

type QuestionnaireErrorProps = {
  errorMessage?: string | null
  formElementId?: string
}

export const QuestionnaireError = ({ errorMessage, formElementId }: QuestionnaireErrorProps) => {
  return (
    <ErrorSummary className="question-error-summary">
      <ErrorSummary.Title>There is a problem</ErrorSummary.Title>
      <ErrorSummary.Body>
        <a href={`#${formElementId}`} className="question-error-summary__body-text">
          {errorMessage ?? "This field is required"}
        </a>
      </ErrorSummary.Body>
    </ErrorSummary>
  )
}
